import Layout from '../../pages/layout'
import { retrunAssets } from '../../utils/getAssets'
import GeneralCardsPage from './generalCardsPage'

const EduTourism = ({ data }) => {
  return <GeneralCardsPage data={data} />
}

export default EduTourism
